import React from 'react';
import Router from './router';

export default function App(){
  return(
    <>
     
      <Router/>
     
      
    </>
  )
}